
import React from 'react';
import AMCConstants from './AMCConstants';
import ZUtil from './zutil';
import ZProps from './zprops';
import ZLog from "./zlog";
import {APP} from "./App"
import {ZOO} from "./zoo";
import Zoo from "./zoo";
import ZooBillingPage from "./ZooBillingPage";
import ZooSearchPage from "./ZooSearchPage";
import AMCAboutPage from "./AMCAboutPage";
import AMCTermsPage from "./AMCTermsPage";
import AMCPrivacyPage from "./AMCPrivacyPage";
import ZooNothingFoundPage from "./ZooNothingFoundPage";
import AMCPlansAndPricingPage from "./AMCPlansAndPricingPage";
import ZooHomePage from "./ZooHomePage";
import ZooGotAlgorithmPage from "./ZooGotAlgorithmPage";
import ZooGotDataPage from "./ZooGotDataPage";
import ZooGotModelPage from "./ZooGotModelPage";
import AMCSignUpPage from "./AMCSignUpPage";
import AMCSignInPage from "./AMCSignInPage";
import AMCOrganizationPage from "./AMCOrganizationPage";
import ZooLeaderboardsPage from "./ZooLeaderboardsPage";
//import ZooDemosPage from "./ZooDemosPage";
import ZooProfilePage from "./ZooProfilePage";
import ZooUserProfilePage from "./ZooUserProfilePage";
import ZooUserAccountPage from "./ZooUserAccountPage";
import AMCUserConfirmEmail from "./AMCUserConfirmEmail";
import AMCUserResetPassword from "./AMCUserResetPassword";
import AMCUserPurchaseFailedPage from "./AMCUserPurchaseFailedPage";
//import AMCUserPurchaseCancelledPage from "./AMCUserPurchaseCancelledPage";
import AMCUserPurchaseSuccessPage from "./AMCUserPurchaseSuccessPage";
import ZooTop from "./ZooTop";
import AMCAdmin from "./AMCAdmin";



const createHistory = require("history").createBrowserHistory;

export var ROUTER = null;



var AMCRouter = {
	init() {
		this.history = createHistory();
		this.router_unlisten = this.history.listen((location) => {
			// ${location.pathname}${location.search}${location.hash}
			this._routed(location.pathname + location.search, location.action);
		});
		ROUTER = this;
		this._routed(window.location.pathname);
	},
/*
	// Auth0
	onRedirectCallback(serviceState) {
		// Temporary Firefox workaround
		window.location.hash = window.location.hash; // eslint-disable-line no-self-assign
		this.history.push( serviceState && serviceState.targetUrl ? serviceState.targetUrl : window.location.pathname);
	},
*/
	setRoute(path) {
		ZLog.debug("setRoute: " + path);
		this.history.replace(path); 
	},
	pushRoute(path, e) {
		ZLog.debug("pushRoute: " + path);
		if (e) {
			ZUtil.absorbEvent(e);
		}
		this.history.push(path);
		return false;
	},
	softPushRoute(path) {
		ZLog.debug("softPushRoute: " + path);
		this.softrouted = path;
		this.history.push(path);
	},
/*
	router(path) {
		return () => { ROUTER.pushRoute(path) };
	},
*/
	_routed(path) {
		ZLog.debug("_routed path=" + path);
		if (path.startsWith("/blog") || path.startsWith("/docs")) {
			if (!path.endsWith("index.html")) {
				window.location.href = path + (path[path.length - 1] !== "/" ? "/" : "") + "index.html";
			}
			return;
		}
		if (ZOO) {
			ZOO.closeMenus();
		}
		if (ZProps.get("beta")) {
			// return window.location.href = "/";
			// if (!path.startsWith("/blog") && !path.startsWith("/docs") && !path.startsWith("/-/")) {
			if (!path.startsWith("/-/")) {
				path = "/";
			}
		}
		if (path === this.softrouted) {
			this.softrouted = null;
			return;
		}
		path = decodeURIComponent(path);
		let qp = ZUtil.getQueryParms();
		ZProps.set("queryparms", Object.keys(qp).length === 0 ? null : qp);
		let qmark_index = path.indexOf("?");
		if (qmark_index !== -1) {
			path = path.substring(0, qmark_index);
		}
		ZProps.set("path", path);
		switch (path) {
			case "/" : 			APP.show( <Zoo><ZooHomePage /></Zoo> ); return;
			//case "/welcome" : 		APP.show( <Zoo><ZooHomePage /></Zoo> ); return;
//			case "/home" : 			APP.show( <AutomaticLandingPage /> ); return;
			case "/-/about" : 		APP.show( <Zoo><AMCAboutPage /></Zoo> ); return;
			case "/-/terms" : 		APP.show( <Zoo><AMCTermsPage /></Zoo> ); return;
			case "/-/privacy" : 		APP.show( <Zoo><AMCPrivacyPage /></Zoo> ); return;
//			case "/-/noui" : 		APP.show( <AutomaticNoUI /> ); return;
			case AMCConstants.PRICING_URI : 	APP.show( <Zoo><AMCPlansAndPricingPage /></Zoo> ); return;
//			case AMCConstants.EDITORURI : 	APP.show( <RockstarLandingPage /> ); return;
//			case "/dashboard" : 		APP.show( <Zoo><ZooDashboardPage /></Zoo> ); return;
//			case "/following" : 		APP.show( <Zoo><ZooFollowingPage /></Zoo> ); return;
//			case "/likes" : 		APP.show( <Zoo><ZooLikesPage /></Zoo> ); return;
			case "/leaderboards" : 		APP.show( <Zoo><ZooLeaderboardsPage /></Zoo> ); return;
			case "/account" : 		APP.show( <Zoo><ZooUserAccountPage /></Zoo> ); return;
			case "/signup" : 		APP.show( <Zoo><AMCSignUpPage /></Zoo> ); return;
			case "/signin" : 		APP.show( <Zoo><AMCSignInPage /></Zoo> ); return;
			case "/gotdata" : 		APP.show( <Zoo><ZooGotDataPage /></Zoo> ); return;
			case "/gotmodel" : 		APP.show( <Zoo><ZooGotModelPage /></Zoo> ); return;
			case "/gotalgorithm" : 		APP.show( <Zoo><ZooGotAlgorithmPage /></Zoo> ); return;
//			case "/demos" : 		APP.show( <Zoo><ZooDemosPage /></Zoo> ); return;
			case "/zoo" : 			APP.show( <Zoo><ZooTop /></Zoo> ); return;
			case "/billing" : 		APP.show( <Zoo><ZooBillingPage /></Zoo> ); return;
			case "/beta" : 			APP.show( <Zoo><AMCSignInPage banner_label="Sign in to the automatic.ai Beta" hide_footers={true} contact_footers={true} class_name={"BetaSignIn"} /></Zoo> ); return;
			default:			break;
		}

		ZLog.debug("path=" + path);

		if (path.startsWith("/purchase/success")) {
			APP.show( <Zoo><AMCUserPurchaseSuccessPage /></Zoo> );
			return;
		}
		if (path.startsWith("/purchase/failed")) {
			APP.show( <Zoo><AMCUserPurchaseFailedPage /></Zoo> );
			return;
		}
		if (path.startsWith("/account/confirm/")) {
			APP.show( <Zoo><AMCUserConfirmEmail code={path.split("/").pop()} /></Zoo> );
			return;
		}
		if (path.startsWith("/admin")) {
			let user = ZProps.get("user");
			if (user && user.admin) {
				APP.show( <Zoo><AMCAdmin key={path} /></Zoo> );
			} else {
				this.pushRoute("/");
			}
			return;
		}
		if (path.startsWith("/organizations")) {
			APP.show( <Zoo><AMCOrganizationPage key={path} /></Zoo> );
			return;
		}
		if (path.startsWith("/account/forgot/")) {
			APP.show( <Zoo><AMCUserResetPassword code={path.split("/").pop()} /></Zoo> );
			return;
		}
		if (path.startsWith("/leaderboards/")) {
			APP.show( <Zoo key={path}><ZooLeaderboardsPage key={path} path={path.substring("/leaderboards/".length)} /></Zoo> );
			return;
		}
		if (path.startsWith("/search/")) {
			APP.show( <Zoo key={path} search={true}><ZooSearchPage key={path} path={path.substring("/search/".length)} /></Zoo> );
			return;
		}
		if (path.startsWith("/tag/")) {
			APP.show( <Zoo key={path} search={true}><ZooSearchPage key={path} path={"tag:" + path.substring("/tag/".length)} /></Zoo> );
			return;
		}
		// /zoo/<item_uri>
		if (path.startsWith("/zoo/")) {
			APP.show( <Zoo><ZooProfilePage key={path} item_uri={path.split("/").slice(2).join("/")} /></Zoo> )
			return;
		}

		let pathparts = path.substring(1).split("/");
		// of form: /<useruri>[/ likes | follows | leaderboards ... ]
		if (pathparts.length === 2 && (path.endsWith("/likes") || path.endsWith("/stars"))) {
			APP.show( <Zoo><ZooUserProfilePage tab={pathparts[1]} target_user_uri={pathparts[0]} /></Zoo> )
			return;
		} 
		//if (path === "/" + ZProps.get("user").uri) {
		if (pathparts.length === 1) {
			APP.show( <Zoo><ZooUserProfilePage target_user_uri={pathparts[0]} /></Zoo> )
			return;
		}
		APP.show( <Zoo><ZooNothingFoundPage /></Zoo> )
		return;

	},
		
}
export default AMCRouter;



// WEBPACK FOOTER //
// ./src/AMCRouter.js